/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const ChasesandStepsIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 42 42"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-190,-1050)">
      <g id="Chases-and-Steps" transform="matrix(0.542569,0,0,0.571048,169.757,377.722)">
        <g transform="matrix(0.629786,-2.56435e-16,-1.00255e-16,0.598377,-1519.69,1177.29)">
          <g id="backing">
            <path
              d="M2594.75,19.851L2594.75,102.551C2594.75,113.507 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.507 2472.35,102.551L2472.35,19.851C2472.35,8.895 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.895 2594.75,19.851Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(1,0,0,-1,0,2428.69)">
          <path
            d="M98.956,1233.91L111.969,1233.89L111.969,1228.48L95.393,1228.5L95.392,1228.47L89.701,1228.47L89.701,1228.51L89.701,1233.92L89.708,1233.92L89.715,1239.12L61.56,1239.15L61.567,1233.91L61.574,1233.91L61.574,1228.5L61.574,1228.48L55.883,1228.48L55.883,1228.49L39.306,1228.47L39.306,1233.88L52.238,1233.89L44.283,1241.92L48.192,1245.85L55.869,1238.11L55.868,1239.16L55.865,1239.16L55.865,1244.57L95.41,1244.52L95.41,1239.11L95.407,1239.11L95.406,1238.2L102.991,1245.85L106.9,1241.92L98.956,1233.91ZM48.839,1198.77L38.567,1198.78L38.567,1204.19L113.009,1204.09L113.009,1198.68L102.811,1198.69L113.009,1188.5L113.009,1183.09L38.567,1183.19L38.567,1188.6L48.839,1198.77ZM65.556,1198.74L57.474,1198.75L65.567,1190.59L65.556,1198.74ZM94.052,1198.7L86.02,1198.71L86.009,1190.59L94.052,1198.7ZM46.557,1188.59L59.762,1188.57L53.151,1195.24L46.557,1188.59ZM105.099,1188.51L98.425,1195.24L91.77,1188.53L105.099,1188.51ZM80.328,1198.72L71.248,1198.73L71.262,1188.56L80.314,1188.54L80.328,1198.72Z"
            style={{ fill: 'white' }}
          />
        </g>
        <g transform="matrix(0.279632,2.22319e-32,-6.07774e-32,0.281675,-385.755,951.049)">
          <circle cx="1650" cy="921.405" r="24.188" style={{ fill: 'white' }} />
        </g>
      </g>
    </g>
  </svg>,
  'ChasesandStepsIcon',
);
